// React
import React from 'react'
// Hooks
import { useVersionCheck } from 'hooks/useVersionCheck'

/**
 * A fixed-position banner that appears at the top of the screen when a new
 * version of the app has been deployed. Prompts the user to refresh so they
 * pick up the latest code and avoid chunk-load errors.
 */
const VersionUpdateBanner: React.FC = () => {
  const updateAvailable = useVersionCheck()

  if (!updateAvailable) return null

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        padding: '10px 20px',
        background: 'linear-gradient(135deg, #0f6cbd 0%, #8dddd8 100%)',
        color: '#ffffff',
        fontSize: 14,
        fontWeight: 500,
        fontFamily: 'Poppins, Open Sans, sans-serif',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
      }}
    >
      <span>A new version of Purchase Pro&trade; is available.</span>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '6px 16px',
          backgroundColor: '#ffffff',
          color: '#0f6cbd',
          border: 'none',
          borderRadius: 6,
          fontSize: 13,
          fontWeight: 600,
          fontFamily: 'Poppins, Open Sans, sans-serif',
          cursor: 'pointer',
          transition: 'opacity 0.2s'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.opacity = '0.85'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.opacity = '1'
        }}
      >
        Refresh Now
      </button>
    </div>
  )
}

export { VersionUpdateBanner }
